import { localState } from "./Context";
import { seed } from "@ngneat/falso";

export type ActionType = {
    type: string;
    payload: any;
    callback?: Function;
};

export const globalState: localState = {
    foundResults: [],
    showResults: false,
};

seed("some-constant-seed");
